function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.818.682v1.023H4.091V.682a.682.682 0 0 0-1.364 0v1.023h-.682A2.043 2.043 0 0 0 0 3.75v13.295a2.043 2.043 0 0 0 2.045 2.046h10.91A2.043 2.043 0 0 0 15 17.045V3.75a2.043 2.043 0 0 0-2.045-2.045h-.682V4.09c.003.925-1.365.892-1.364 0V1.705H8.182V.682a.682.682 0 0 0-1.364 0zm-4.09 1.023V4.09c-.005.916 1.358.9 1.363 0V1.705H2.727zm8.181 0h1.364V.682a.682.682 0 0 0-1.364 0v1.023zm.682 5.113H3.409a.682.682 0 0 0 0 1.364h8.182a.682.682 0 0 0 0-1.364zm0 3.41H3.409a.682.682 0 0 0 0 1.363h8.182a.682.682 0 0 0 0-1.364zm0 3.408H3.409a.682.682 0 0 0 0 1.364h8.182a.682.682 0 0 0 0-1.364zM6.818 1.705V4.09c-.003.882 1.365.933 1.364 0V1.705H6.818z",
  fill: "#0b1319",
  fillRule: "evenodd"
});

var SvgNote = function SvgNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note.b80183ee.svg";
export { ForwardRef as ReactComponent };